import apiCreate from './functions/apiCreate';
import apiRead from './functions/apiRead';
import apiUpdate from './functions/apiUpdate';
import apiDelete from './functions/apiDelete';
import apiReadCollection from './functions/apiReadCollection';

const crud = {
  create: apiCreate,
  read: apiRead,
  readCollection: apiReadCollection,
  update: apiUpdate,
  delete: apiDelete
};

export default crud;
